import type {
    InputDimensionConfiguration,
    InputDimensionProps,
} from "../../components/dimensions/InputDimension";
import { DimensionTypes } from "../../types/dimensions";
import { InputComponentTypes } from "../../types/inputs";

import type { DimensionFixtureExample } from ".";

export const inputDimensionConfiguration: Record<
    string,
    InputDimensionConfiguration
> = {
    basic: {
        type: InputComponentTypes.TEXT,
        label: "basic input",
    },
};

export class InputDimensionExampleProps {
    public static basic: InputDimensionProps = {
        id: "input-basic",
        type: DimensionTypes.INPUT,
        configuration: inputDimensionConfiguration.basic,
        dependencies: [],
        optional: false,
    };
}

export class InputDimensionExamples {
    public static basic: DimensionFixtureExample = {
        id: "input-basic",
        name: "input dimension - basic",
        description: "basic input dimension",
        dimensions: [[InputDimensionExampleProps.basic]],
    };
}
